import MockAdapter from 'axios-mock-adapter/types'

export function mockEarnsLucky(mocker: MockAdapter) {
  mocker.onGet(RegExp('^/earns/luck/list')).reply((config) => {
    return [
      200,
      {
        code: 200,
        data: [
          '0x0000000000000000000000000000000000000001',
          '0x0000000000000000000000000000000000000002',
          '0x0000000000000000000000000000000000000003',
          '0x0000000000000000000000000000000000000004',
          '0x0000000000000000000000000000000000000005',
          '0x0000000000000000000000000000000000000006',
          '0x0000000000000000000000000000000000000007',
          '0x0000000000000000000000000000000000000008',
          '0x0000000000000000000000000000000000000009',
          '0x000000000000000000000000000000000000000a',
          '0x000000000000000000000000000000000000000b',
          '0x000000000000000000000000000000000000000c',
          '0x000000000000000000000000000000000000000d',
          '0x000000000000000000000000000000000000000e',
          '0x000000000000000000000000000000000000000f',
        ],
      },
    ]
  })
}
